import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import FinOpsSummaryCards from "./FinOpsSummaryCards";
import FinOpsMonthlyCostChart from "./FinOpsMonthlyCostChart";
import FinOpsTopServices from "./FinOpsTopServices";

const FinOpsDashboardContent = ({ data }) => {
  if (!data) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: 400,
          color: "text.secondary",
        }}
      >
        <Typography variant="body1">No data available</Typography>
      </Box>
    );
  }

  return (
    <Box>
      {/* Summary Cards */}
      <FinOpsSummaryCards data={data} />

      {/* Charts and Tables Grid */}
      <Grid container spacing={3}>
        {/* Monthly Cost Chart - Takes 2/3 width */}
        <Grid item xs={12} md={8}>
          <FinOpsMonthlyCostChart data={data} />
        </Grid>

        {/* Top Services - Takes 1/3 width */}
        <Grid item xs={12} md={4}>
          <FinOpsTopServices 
            topServicesCurrentMonth={data.top3ServicesCurrentMonth}
            topServicesPreviousMonth={data.top3ServicesPreviousMonth}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FinOpsDashboardContent;
